<template>
  <div class="fix-popup-wrap">
    <div class="fix-popup">
      <template v-if="opened">
        <h4>PART_ANNUAL_WAGES</h4>
        <div>{{ participant.id }}</div>
        <div>
          Deferral Rate <strong>{{ currentDeferralRateFormat }}</strong>
          <template v-if="currentDeferralRate > maxDeferralRate">
            > <strong>{{ percentFormat(maxDeferralRate) }}</strong>
          </template>
        </div>

        <roe-error-message :field="$v.participant.estimated_annual_wages">
          <input
            type="number"
            v-model="participant.estimated_annual_wages"
            name="estimated_annual_wages"
            required
          />
          <label class="input-label-inside">$</label>
        </roe-error-message>

        <div class="action-btn-wrap">
          <div class="btn-wrap">
            <button
              class="btn-primary"
              :disabled="$v.participant.estimated_annual_wages.$invalid"
              @click="updateParticipant"
            >
              Save
            </button>
          </div>
          <div class="btn-wrap">
            <button class="btn-secondary" @click="$emit('close')">
              Cancel
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { UPDATE_PARTICIPANT } from "@/store/actions.type";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { SHOW_FORM_ERRORS } from "@/store/mutations.type";
import { required, minValue } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  name: "RoeFixParticipantDeferralRateForm",
  components: {
    RoeErrorMessage
  },
  props: {
    opened: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      participant: {},
      valueToCalcDeferralRate: null
    };
  },
  validations() {
    return {
      participant: {
        estimated_annual_wages: {
          required,
          minValue: minValue(1),
          currency: true
        }
      }
    };
  },
  computed: {
    ...mapGetters(["maxDeferralRate"]),
    currentDeferralRate() {
      return (
        this.valueToCalcDeferralRate / this.participant.estimated_annual_wages
      );
    },
    currentDeferralRateFormat() {
      return this.percentFormat(this.currentDeferralRate);
    },
    maxDeferralRateFormat() {
      return this.percentFormat(this.maxDeferralRate);
    }
  },
  methods: {
    percentFormat(value) {
      return `${Number((value * 100).toFixed(2))}%`;
    },
    updateParticipant() {
      this.$store.dispatch(UPDATE_PARTICIPANT, {
        reportId: this.$router.currentRoute.params.id,
        params: {
          id: this.participant.id,
          estimated_annual_wages: this.participant.estimated_annual_wages
        }
      });
      this.$emit("close");
    },
    initForm(participant) {
      this.participant = participant;
      this.valueToCalcDeferralRate =
        this.participant.deferral_rate *
        this.participant.estimated_annual_wages;
      this.$store.commit(SHOW_FORM_ERRORS);
      this.$emit("open");
    }
  }
};
</script>
